export const getProjectQueryKey = (accountId: string, projectId: string) => [
  accountId,
  projectId,
  'project',
];
